export default __webpack_public_path__ + "static/media/sign-out-primary.88e9be05.svg";